export const shareToTwitter = (title: string) => {
  const url = window.location.href;

  window.open(
    `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)} - k․dev`,
    "_blank",
    "location=yes,height=570,width=520,scrollbars=yes,status=yes",
  );
};
